module.exports = __webpack_public_path__ + "static/media/step-3-en.0d951698.jpg";